import DefaultState from './defaultState'

export default new DefaultState()
